export default {
    'add-a-new-customer-type': 'Add a new customer type'
}